import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useI18n } from '../../contexts/I18nContext';

const NAV_KEYS = [
  { labelKey: 'fortune', items: [
    { to: '/fortune', sym: '命', label: '사주' },
    { to: '/charge', sym: '價', label: '가격표' },
  ]},
  { labelKey: 'tarotAndGunghap', items: [
    { to: '/tarot', sym: '卦', label: '타로' },
    { to: '/gunghap', sym: '合', label: '궁합' },
  ]},
];

const DESKTOP_LINKS = [
  { to: '/', label: '홈' },
  { to: '/fortune', label: '사주' },
  { to: '/tarot', label: '타로' },
  { to: '/gunghap', label: '궁합' },
  { to: '/charge', label: '가격표' },
];

const ADMIN_EMAILS = ['mobidicmcn@gmail.com', 'master@sktec.kr', 'admin@mobidicsaju.com', 'admin@example.com', 'vividsaebom@gmail.com'];

export function Header() {
  const { user, logout, isAuthenticated } = useAuth();
  const { t, lang, setLang, LANG_OPTIONS } = useI18n();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [userMenu, setUserMenu] = useState(false);
  const [langMenu, setLangMenu] = useState(false);
  const userRef = useRef(null);
  const langRef = useRef(null);

  useEffect(() => {
    const h = (e) => {
      if (userRef.current && !userRef.current.contains(e.target)) setUserMenu(false);
      if (langRef.current && !langRef.current.contains(e.target)) setLangMenu(false);
    };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  useEffect(() => { setMobileOpen(false); setUserMenu(false); }, [location.pathname]);

  const doLogout = () => { logout(); navigate('/'); };
  const canAdmin = Boolean(user?.isAdmin || user?.role === 'admin' || ADMIN_EMAILS.includes(user?.email));

  return (
    <>
      <header className="header-root" style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 'var(--z-header)',
        background: 'rgba(245,240,255,0.72)',
        backdropFilter: 'blur(40px) saturate(200%) brightness(1.04)',
        WebkitBackdropFilter: 'blur(40px) saturate(200%) brightness(1.04)',
        borderBottom: '1px solid var(--glass-border)',
        boxShadow: '0 4px 24px rgba(100,60,200,0.1), inset 0 1px 0 rgba(255,255,255,0.9)',
        padding: '0 16px',
      }}>
        {/* Liquid Glass shimmer overlay */}
        <div style={{
          position: 'absolute', inset: 0, pointerEvents: 'none',
          background: 'linear-gradient(180deg, rgba(255,255,255,0.25) 0%, transparent 60%)',
        }} />
        <div style={{
          position: 'absolute', left: 0, right: 0, top: 0, height: 1, pointerEvents: 'none',
          background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.8), transparent)',
        }} />
        <div style={{ maxWidth: 1080, margin: '0 auto', display: 'flex', alignItems: 'center', height: 52, gap: 8 }}>
          {/* Logo */}
          <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0, textDecoration: 'none' }}>
            <span className="saju2you-logo-glyph">命</span>
            <span className="saju2you-brand-text">
              <strong>청명당</strong>
              <small>淸明堂</small>
            </span>
          </Link>

          <nav className="saju2you-desktop-nav" aria-label="주요 메뉴">
            {DESKTOP_LINKS.map(item => (
              <Link key={item.to} to={item.to} className={location.pathname === item.to ? 'active' : ''}>
                {item.label}
              </Link>
            ))}
            {canAdmin && (
              <Link to="/admin" className={location.pathname.startsWith('/admin') ? 'active' : ''}>
                관리자 ERP
              </Link>
            )}
          </nav>

          {/* Right side */}
          <div className="header-right" style={{ display: 'flex', alignItems: 'center', gap: 8, marginLeft: 'auto', flexShrink: 0 }}>
            {isAuthenticated ? (
              <>
              <div ref={userRef} className="header-nav-mobile-hide" style={{ position: 'relative' }}>
                <button onClick={() => setUserMenu(!userMenu)} style={{
                  padding: '6px 14px', borderRadius: 'var(--radius-full)',
                  background: 'var(--glass-bg-subtle)', border: '1px solid var(--glass-border)',
                  fontSize: 'var(--text-sm)', fontWeight: 600, color: 'var(--text-primary)',
                  display: 'flex', alignItems: 'center', gap: 6,
                }}>
                  <span style={{ fontFamily: 'var(--font-serif)', fontSize: 13, color: 'var(--accent-gold)' }}>人</span>
                  {user?.nickname || user?.name || '사용자'}
                </button>
                {userMenu && (
                  <div style={{
                    position: 'absolute', top: '100%', right: 0, marginTop: 8,
                    minWidth: 180, padding: 8,
                    background: 'var(--glass-bg-strong)',
                    backdropFilter: 'var(--glass-blur-heavy)',
                    WebkitBackdropFilter: 'var(--glass-blur-heavy)',
                    border: '1px solid var(--glass-border-strong)',
                    borderRadius: 'var(--radius-md)',
                    boxShadow: 'var(--glass-shadow-lg)',
                    zIndex: 200,
                  }}>
                    <Link to="/charge" onClick={() => setUserMenu(false)} style={{
                      width: '100%', display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px',
                      borderRadius: 'var(--radius-sm)', fontSize: 'var(--text-sm)', color: 'var(--text-primary)',
                    }}
                      onMouseEnter={(e) => e.currentTarget.style.background = 'var(--glass-bg-subtle)'}
                      onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}>
                      <span style={{ fontFamily: 'var(--font-serif)', fontSize: 13, color: 'var(--accent-gold)' }}>價</span> 이용권 충전
                    </Link>
                    {canAdmin && (
                      <Link to="/admin" onClick={() => setUserMenu(false)} style={{
                        width: '100%', display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px',
                        borderRadius: 'var(--radius-sm)', fontSize: 'var(--text-sm)', color: 'var(--text-primary)',
                      }}
                        onMouseEnter={(e) => e.currentTarget.style.background = 'var(--glass-bg-subtle)'}
                        onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}>
                        <span style={{ fontFamily: 'var(--font-serif)', fontSize: 13, color: 'var(--accent-gold)' }}>管</span> 관리자
                      </Link>
                    )}
                    <button onClick={doLogout} style={{
                      width: '100%', display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px',
                      borderRadius: 'var(--radius-sm)', fontSize: 'var(--text-sm)', color: 'var(--accent-red)',
                    }}
                      onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(239,68,68,0.06)'}
                      onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}>
                      {t.logout}
                    </button>
                  </div>
                )}
              </div>
              </>
            ) : (
              <div className="header-nav-mobile-hide" style={{ display: 'flex', gap: 8 }}>
                <Link to="/login" className="glass-btn" style={{ padding: '8px 18px', fontSize: 'var(--text-sm)' }}>{t.login}</Link>
                <Link to="/register" className="glass-btn-primary" style={{ padding: '8px 18px', fontSize: 'var(--text-sm)' }}>{t.register}</Link>
              </div>
            )}

            {/* Language selector */}
            <div ref={langRef} style={{ position: 'relative' }}>
              <button onClick={() => setLangMenu(!langMenu)} aria-label="언어 선택" style={{
                padding: '8px 12px', borderRadius: 'var(--radius-full)',
                background: 'var(--glass-bg-subtle)', border: '1px solid var(--glass-border)',
                fontSize: 16, cursor: 'pointer', display: 'flex', alignItems: 'center',
                minWidth: 44, minHeight: 44,
              }}>
                {LANG_OPTIONS.find(l => l.code === lang)?.flag || '🌐'}
              </button>
              {langMenu && (
                <div style={{
                  position: 'absolute', top: '100%', right: 0, marginTop: 8,
                  minWidth: 140, padding: 4,
                  background: 'var(--glass-bg-strong)',
                  backdropFilter: 'var(--glass-blur-heavy)',
                  WebkitBackdropFilter: 'var(--glass-blur-heavy)',
                  border: '1px solid var(--glass-border-strong)',
                  borderRadius: 'var(--radius-md)',
                  boxShadow: 'var(--glass-shadow-lg)',
                  zIndex: 100,
                }}>
                  {LANG_OPTIONS.map(opt => (
                    <button key={opt.code} onClick={() => { setLang(opt.code); setLangMenu(false); }} style={{
                      width: '100%', display: 'flex', alignItems: 'center', gap: 8,
                      padding: '8px 12px', borderRadius: 'var(--radius-sm)',
                      fontSize: 'var(--text-sm)', fontWeight: lang === opt.code ? 700 : 400,
                      background: lang === opt.code ? 'var(--glass-bg-subtle)' : 'transparent',
                      border: 'none', cursor: 'pointer', color: 'var(--text-primary)',
                    }}>
                      <span style={{ fontSize: 16 }}>{opt.flag}</span> {opt.label}
                    </button>
                  ))}
                </div>
              )}
            </div>

            {/* Hamburger (far right) */}
            <button onClick={() => setMobileOpen(!mobileOpen)} style={{ padding: 8 }}>
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                {mobileOpen
                  ? <path d="M6 6L16 16M16 6L6 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  : <path d="M3 6H19M3 11H19M3 16H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>}
              </svg>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile slide-out */}
      {mobileOpen && (
        <div style={{
          position: 'fixed', inset: 0, zIndex: 99, background: 'rgba(0,0,0,0.5)',
          backdropFilter: 'blur(6px)',
        }} onClick={() => setMobileOpen(false)}>
          <nav onClick={(e) => e.stopPropagation()} style={{
            position: 'absolute', top: 0, right: 0, bottom: 0, width: 280,
            background: 'var(--glass-bg-strong)',
            backdropFilter: 'var(--glass-blur-heavy)',
            WebkitBackdropFilter: 'var(--glass-blur-heavy)',
            borderLeft: '1px solid var(--glass-border)',
            padding: '72px 16px 24px', overflowY: 'auto',
            animation: 'slideInRight 0.25s ease',
          }}>
            <Link to="/" style={{ display: 'block', padding: '12px 16px', fontWeight: 700, fontSize: 'var(--text-base)', borderRadius: 'var(--radius-sm)' }}>
              {t.home}
            </Link>
            {NAV_KEYS.map((g, i) => (
              <div key={i} style={{ marginTop: 12 }}>
                <div style={{ padding: '8px 16px', fontSize: 'var(--text-xs)', fontWeight: 700, color: 'var(--text-tertiary)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                  {t[g.labelKey]}
                </div>
                {g.items.map((item, j) => (
                  <Link key={j} to={item.to} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 16px', borderRadius: 'var(--radius-sm)', fontSize: 'var(--text-sm)', fontWeight: 500 }}>
                    <span style={{ fontFamily: 'var(--font-serif)', fontSize: 13, color: 'var(--accent-gold)', opacity: 0.6, width: 18, textAlign: 'center' }}>{item.sym}</span> {item.label || t[item.nameKey]}
                  </Link>
                ))}
              </div>
            ))}
            {isAuthenticated && (
              <div style={{ marginTop: 12 }}>
                <div style={{ padding: '8px 16px', fontSize: 'var(--text-xs)', fontWeight: 700, color: 'var(--text-tertiary)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                  {user?.nickname || user?.name || '사용자'}
                </div>
                <Link to="/charge" style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 16px', borderRadius: 'var(--radius-sm)', fontSize: 'var(--text-sm)', fontWeight: 500 }}>
                  <span style={{ fontFamily: 'var(--font-serif)', fontSize: 13, color: 'var(--accent-gold)', opacity: 0.8, width: 18, textAlign: 'center' }}>價</span> 이용권 충전
                </Link>
                {canAdmin && (
                  <Link to="/admin" style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 16px', borderRadius: 'var(--radius-sm)', fontSize: 'var(--text-sm)', fontWeight: 500 }}>
                    <span style={{ fontFamily: 'var(--font-serif)', fontSize: 13, color: 'var(--accent-gold)', opacity: 0.8, width: 18, textAlign: 'center' }}>管</span> 관리자
                  </Link>
                )}
                <button onClick={doLogout} style={{
                  width: '100%', display: 'flex', alignItems: 'center', gap: 10, padding: '10px 16px',
                  borderRadius: 'var(--radius-sm)', fontSize: 'var(--text-sm)', fontWeight: 500, color: 'var(--accent-red)',
                  background: 'transparent', border: 'none', textAlign: 'left',
                }}>
                  <span style={{ fontFamily: 'var(--font-serif)', fontSize: 13, opacity: 0.6, width: 18, textAlign: 'center' }}>出</span> {t.logout}
                </button>
              </div>
            )}
            {!isAuthenticated && (
              <div style={{ marginTop: 24, display: 'flex', gap: 8, padding: '0 16px' }}>
                <Link to="/login" className="glass-btn" style={{ flex: 1, justifyContent: 'center' }}>{t.login}</Link>
                <Link to="/register" className="glass-btn-primary" style={{ flex: 1, justifyContent: 'center' }}>{t.register}</Link>
              </div>
            )}
          </nav>
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .desktop-only { display: none !important; }
        }
      `}</style>
    </>
  );
}
